import { PinType, MapConfig } from "../types";

// Pin settings
export const PIN_CONFIG = {
  MAX_DURATION_SECONDS: 30, // ピンが消えるまでの秒数
  DEFAULT_SIZE_PX: 80,
  FONT_SIZE_RATIO: 0.45,
  MIN_FONT_SIZE_PX: 10,
  CLEANUP_INTERVAL_MS: 1000,
};

// Tap/Touch settings
export const TAP_CONFIG = {
  SINGLE_TAP_MS: 250,
  DOUBLE_TAP_DETECTION_MS: 400,
  LONG_PRESS_MS: 600,
  MOVE_THRESHOLD_PX: 5,
};

// Rotation
export const ROTATION_CONFIG = {
  STEP_DEGREES: 90,
  FULL_CIRCLE_DEGREES: 360,
};

// UI
export const UI_CONFIG = {
  Z_INDEX_CONTROLS: 1000,
  Z_INDEX_LEGEND_ROTATION: 50,
  Z_INDEX_MAP_LAYER: 1,
};

// Pin colors
export const PIN_COLORS: Record<PinType, string> = {
  [PinType.Enemy]: "red",
  [PinType.Ally]: "blue",
  [PinType.General]: "orange",
};

// Available maps
export const AVAILABLE_MAPS: MapConfig[] = [
  { name: "BLKFOX 福生店", src: "/maps/blkfox福生店.png" },
  { name: "H.E.A.D.S 川越", src: "/maps/heads川越.jpg" },
];

// Local storage keys
export const STORAGE_KEYS = {
  SELECTED_MAP: "selectedMap",
} as const;
